import { whiteLabelStore } from 'Models/WhiteLabelStore';
import { appConfigStore } from 'Models/AppConfigStore';
import { useNavigate } from 'react-router-dom';
import {
	clearBookingWizardData,
	getBookingWizardData,
} from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardDataStore';
import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';
import { VehicleBookingButton } from './VehicleBookingButton';
import { PassengerBookingButton } from './PassengerBookingButton';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import * as React from 'react';
import { Button, Colors, Display } from '../../Button/Button';
import { clearFerryBookingTransactionIdFromStorage } from 'Services/Api/_HumanWritten/BookingService/BookingService';
import { useOrganisationStore } from 'Global/Organisations/OrganisationsStore';
import If from '../../If/If';
import EventList from '../Events/EventCards/EventList';

export interface NewDefaultHomeProps {
	contactUs: boolean;
	show: boolean;
}

function MultiOrgHomeBookingType({ contactUs, show }: NewDefaultHomeProps) {
	const navigate = useNavigate();
	const orgStore = useOrganisationStore();
	const onScheduleClick = () => {
		clearBookingWizardData();
		navigate('/ferry-schedule');
	};

	const onSearch = (type: TabSelected) => {
		const wizardData = getBookingWizardData({
			type: type,
		});
		if (wizardData.wizardMode === 'ALTERATION') {
			clearFerryBookingTransactionIdFromStorage();
			// This will clear the new and old booking wizard data (if any)
			clearBookingWizardData();
		}
	};

	// Show intercom if the user has entered the application from a contact us link,
	// an assumption is that they have just navigated to the page.
	if (contactUs && !!(window as any).Intercom) {
		(window as any).Intercom('show');
	}

	// Get the booking buttons in order of priority and depending on the config (whether they are enabled or not)
	const bookingButtons = [];

	if (whiteLabelStore.defaultBookingType === 'vehicle') {
		if (appConfigStore.vehicleEnabled) {
			bookingButtons.push(<VehicleBookingButton key="vehicle-booking-button" onSearch={onSearch} />);
		}
		if (appConfigStore.showPassengerBookingOption) {
			bookingButtons.push(<PassengerBookingButton key="passenger-booking-button" onSearch={onSearch} />);
		}
	} else if (whiteLabelStore.defaultBookingType === 'passenger') {
		if (appConfigStore.showPassengerBookingOption) {
			bookingButtons.push(<PassengerBookingButton key="passenger-booking-button" onSearch={onSearch} />);
		}
		if (appConfigStore.vehicleEnabled) {
			bookingButtons.push(<VehicleBookingButton key="vehicle-booking-button" onSearch={onSearch} />);
		}
	}

	return (
		<div className={classNames('ferry-booking-page__container', show ? 'show' : '')}>
			<div className={classNames('title-container', show ? 'show' : '')}>
				<p>
					<FormattedMessage id="multi-org-homepage__page-title__label" defaultMessage="LET'S GO TO" />
				</p>
				<h1>{orgStore.selectedOrganisation?.name}</h1>
				<If condition={orgStore.selectedOrganisation?.hasFerries ?? true}>
					<Button
						className="check-ferry-schedule__glass-button icon-calendar icon-left hide-underline"
						onClick={onScheduleClick}
						colors={Colors.Primary}
						display={Display.Solid}
					>
						<FormattedMessage id="homepage__check-schedule__button" defaultMessage="Check ferry schedule" />
					</Button>
				</If>
			</div>
			<If condition={orgStore.selectedOrganisation?.hasFerries}>
				<div className="home-content__container begin-booking__container glass">
					<p className="white">
						<FormattedMessage
							id="multi-org-homepage__ferry-booking-section__label"
							defaultMessage="FERRY"
						/>
					</p>
					<h4 className="white">
						<FormattedMessage
							id="multi-org-homepage__ferry-booking-section__sub-label"
							defaultMessage="Select your booking type"
						/>
					</h4>
					<div
						className={classNames('booking-type-buttons__container', {
							'fill-row': bookingButtons.length === 1,
						})}
					>
						{bookingButtons}
					</div>
				</div>
			</If>
			<If condition={orgStore.selectedOrganisation?.hasTours ?? false}>
				<EventList searchState={null} />
			</If>
		</div>
	);
}

export default MultiOrgHomeBookingType;
